import React, { useState, useEffect } from 'react';
import { FiChevronUp } from 'react-icons/fi';
import './BackToTop.css';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      className="back-to-top"
      onClick={scrollToTop}
      title="Back to top"
      aria-label="Scroll to top of page"
    >
      <FiChevronUp className="back-to-top-icon" aria-hidden />
    </button>
  );
};

export default BackToTop;
